import createSvgIcon from '../createSvgIcons'

/**
 * @ignore - internal component.
 */
export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7 3.38223L11.2424 7.53667C11.8732 8.15444 12.896 8.15444 13.5269 7.53667C14.1577 6.9189 14.1577 5.91729 13.5269 5.29952L8.90375 0.772217C7.85234 -0.257404 6.14766 -0.257407 5.09625 0.772215L0.473135 5.29952C-0.157712 5.91729 -0.157712 6.9189 0.473135 7.53667C1.10398 8.15444 2.12679 8.15444 2.75763 7.53667L7 3.38223Z"
    fill="currentColor"
  />,
  'InputChevronUp'
)
